// extracted by mini-css-extract-plugin
export var container = "_2-0";
export var formArea = "_2-5";
export var formWrapper = "_2-4";
export var fullWidthButton = "_2-6";
export var leftPanel = "_2-1";
export var loadingSpinner = "_2-8";
export var logo = "_2-3";
export var logoLockup = "_2-2";
export var primaryActionButton = "_2-7";
export var spin = "_2-9";